<template>
  <v-container class="pd16">
    <strong class="t-cont-title">전자서명 조회</strong>
    <p class="esign-notice">완료된 건만 확인 가능합니다.</p>

    <ul class="esign-list" v-if="docs.length">
      <li class="esign-list__item" v-for="doc in docs" :key="doc.doc_id">
        <span class="esign-list__name">{{ doc.doc_name }}</span>
        <button
          type="button"
          class="esign-list__button"
          :disabled="viewingDocId === doc.doc_id"
          @click="viewDoc(doc)"
        >
          {{ viewingDocId === doc.doc_id ? "확인중" : "다운로드" }}
        </button>
      </li>
    </ul>

    <strong class="t-cont-title text-center mt-10" v-else
      >{{ emptyMessage }}</strong
    >
  </v-container>
</template>

<script>
import { getModusignDocs, getModusignDownloadUrl } from "@/api/contract.js";

export default {
  name: "ModusignList",
  data() {
    return {
      docs: [],
      viewingDocId: null,
      emptyMessage: "조회된 전자서명 문서가 없습니다.",
    };
  },
  computed: {
    home() {
      return this.$store.getters.getHome;
    },
  },
  methods: {
    getDocs() {
      getModusignDocs(this.home.id)
        .then((result) => {
          this.docs = result.data;
        })
        .catch((_) => {
          this.docs = [];
          this.emptyMessage = "전자서명 문서를 조회할 수 없습니다.";
        });
    },
    viewDoc(doc) {
      this.viewingDocId = doc.doc_id;

      getModusignDownloadUrl(this.home.id, doc.doc_id)
        .then((result) => {
          if (!result.data || !result.data.download_url) {
            this.$store.commit("ERROR", "문서를 조회할 수 없습니다.");
            return;
          }
          window.open(result.data.download_url, "_blank");
        })
        .catch((_) => {
          this.$store.commit("ERROR", "문서를 조회할 수 없습니다.");
        })
        .finally(() => {
          this.viewingDocId = null;
        });
    },
  },
  created() {
    this.getDocs();
  },
};
</script>

<style scoped>
.esign-notice {
  margin: 0 0 12px;
  text-align: left;
  font-size: 12px;
  line-height: 18px;
  color: #909090;
}

.esign-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.esign-list__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 4px;
  border-bottom: 1px solid #ececec;
}

.esign-list__item:first-child {
  border-top: 1px solid #ececec;
}

.esign-list__name {
  font-size: 14px;
  color: #232323;
  line-height: 20px;
  word-break: break-all;
}

.esign-list__button {
  flex: 0 0 auto;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #ef761d;
  border-radius: 999px;
  background-color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  color: #ef761d;
  white-space: nowrap;
}

.esign-list__button:disabled {
  border-color: #d9d9d9;
  color: #b8b8b8;
}
</style>
